<template>
    <div class="hello">
        <el-container class="sub-container">
            <el-header class="reg-steps-wrap">
                <el-steps :active="step" align-center>
                    <el-step title="步骤1" description="解绑原有手机号码"></el-step>
                    <el-step title="步骤2" description="绑定新手机号码"></el-step>
                </el-steps>
            </el-header>
            <el-main class="reg-wrap">

                <el-form v-show="step==1" :model="oldForm" label-width="150px" :rules="oldRules" ref="oldForm" class="phone-form">
                    <el-form-item label="解绑手机号码：" prop="phone"><el-input type="text" v-model="oldForm.phone" auto-complete="off" clearable :maxlength="11"></el-input></el-form-item>
                    <el-form-item label="验证码：" prop="code">
                        <el-row>
                            <el-col :span="18">
                                <el-input type="text" v-model="oldForm.code" auto-complete="off" clearable :maxlength="6"></el-input>
                            </el-col>
                            <el-col :span="6">
                                <sms-code :get-code="getSmsCode" :check-phone="checkPhone" :step="step" :newPhone="newForm.phone"></sms-code>
                            </el-col>
                        </el-row>
                    </el-form-item>
                    <el-form-item label=""><el-button @click="unbindSubmit">提交</el-button></el-form-item>
                </el-form>
                <el-form v-show="step==2" :model="newForm" label-width="150px" :rules="newRules" ref="newForm" class="phone-form">
                    <el-form-item label="绑定手机号码：" prop="phone"><el-input type="text" v-model="newForm.phone" auto-complete="off" clearable :maxlength="11"></el-input></el-form-item>
                    <el-form-item label="验证码：" prop="code">
                        <el-col :span="18">
                            <el-input type="text" v-model="newForm.code" auto-complete="off" clearable :maxlength="6"></el-input>
                        </el-col>
                        <el-col :span="6">
                            <sms-code :get-code="getSmsCode" :check-phone="checkPhone" :step="step" :newPhone="newForm.phone"></sms-code>
                        </el-col>
                    </el-form-item>
                    <el-form-item label=""><el-button @click="bindSubmit">提交</el-button></el-form-item>
                </el-form>
            </el-main>
        </el-container>
    </div>
</template>

<script type="text/babel">
    import { mapGetters } from 'vuex'
    import apis from '@/store/apis'
    import SMSCode from '@/components/SmsCode'

    export default {
        name: 'supplier-bind',
        data () {
            return {
                step: 1,
                oldForm:{
                    phone:'',
                    code: ''
                },
                oldRules:{
                    phone:[
                        { required: true, message: '请输入原有手机号'}//,
                        // { validator: this.validatePhone, trigger: 'blur'}解绑就是已有的手机
                    ],
                    code: [
                        { required: true, message: '请输入验证码'},
                        { validator: this.validateCode, trigger: 'blur'}
                    ]
                },
                newForm:{
                    phone:'',
                    code: ''
                },
                newRules:{
                    phone:[
                        { required: true, message: '请输入新手机号'},
                        { validator: this.validatePhone, trigger: 'blur'}
                    ],
                    code: [
                        { required: true, message: '请输入验证码'},
                        { validator: this.validateCode, trigger: 'blur'}
                    ]
                },
                isBindSubmitClick: false,
                isUnbindSubmitClick: false,
            }
        },
        components: {
            'sms-code': SMSCode
        },
        methods: {
            checkPhone() {
                let binding = this.step > 1
                let phone = null
                if (binding) {
                    phone = this.newForm.phone
                } else {
                    phone = this.oldForm.phone
                }
                return /^1[3-9]\d{9}$/.test(phone)
            },
            getSmsCode(){
                let binding = this.step > 1
                let phone = null
                if(binding){
                    phone = this.newForm.phone
                }else{
                    phone = this.oldForm.phone
                }

                if(/^1[3-9]\d{9}$/.test(phone)){
                    return apis[binding?'getBindingSmsCode':'getUnBindingSmsCode'](phone)
                }else{
                    return Promise.reject('手机号码不正确')
                }
            },
            unbindSubmit(){
                this.isUnbindSubmitClick = true
                if(!this.checkPhone()) {
                    this.$message({type: 'error', message: '手机号码不正确'})
                    return
                }
                this.$refs.oldForm.validate(valid=>{
                    if(valid){
                        this.step = 2
                    }
                })
            },
            bindSubmit(){
                this.isBindSubmitClick = true
                if(!this.checkPhone()) {
                    this.$message({type: 'error', message: '手机号码不正确'})
                    return
                }
                if(!this.newForm.code) {
                    this.$message({type: 'error', message: '请输入验证码'})
                    return
                }
                // apis.checkPhone(this.newForm.phone).then((res) =>{
                //     if (res.data.result) {
                        apis['checkBindingSmsCode'](this.newForm.phone,this.newForm.code).then((res) =>{
                            if (res.data.result) {

                                this.$alert(res.data.message)

                                this.step = 1
                                this.oldForm = {
                                    phone:'',
                                    code: ''
                                }

                                this.newForm = {
                                    phone:'',
                                    code: ''
                                }

                                callback && callback()
                            } else {
                                this.$alert(res.data.message)
                                callback && callback(new Error(res.data.message))
                            }
                        }, e => {
                            callback && callback(new Error('验证码不正确'))
                        })
                //     }
                // })
            },
            validatePhone(rule, value, callback){
                if(/^1[3-9]\d{9}$/.test(value)){
                    // apis.checkPhone(value).then((res) =>{
                    //     if (res.data.result) {
                    //         callback()
                    //     } else {
                    //         callback(new Error(res.data.message))
                    //     }
                    // }, e => {
                    //     callback()
                    // })
                    callback()
                }else{
                    callback(new Error('手机号码不正确'))
                }
            },
            validateCode(rule, value, callback){

                if(!this.checkPhone()) {
                    this.$message({type: 'error', message: '手机号码不正确'})
                    return
                }

                let binding = this.step > 1

                if (binding ? !this.isBindSubmitClick : !this.isUnbindSubmitClick) {
                    return
                }

                if(binding) {return}

                apis[binding?'checkBindingSmsCode':'checkUnBindingSmsCode'](this[binding?'newForm':'oldForm'].phone,value).then((res) =>{
                    if (res.data.result) {
                        this.$alert(res.data.message)
                        callback()
                    } else {
                        this.$alert(res.data.message)
                        callback(new Error(res.data.message))
                    }
                }, e => {
                    callback(new Error('验证码不正确'))
                })

                this.isBindSubmitClick = false
                this.isUnbindSubmitClick = false
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .sub-container{
        width: 960px;
    }
    .phone-form{
        width: 500px;
        margin: 50px 0 0 180px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Bind.vue